import type { PTSTimestampTable } from '../../workers/types/video-frame-processor';
import type { VIDEO_METADATA_TYPE } from '../constants/constants';
export type DecodedFrameRendererT = {
  decodeAndRenderFrame: (frameIndex: number) => Promise<boolean>;
  clearCanvas: () => void;
};
export type VideoMetadataT = {
  type: typeof VIDEO_METADATA_TYPE.FRAME_TABLE;
  frameTable: PTSTimestampTable;
} | {
  type: typeof VIDEO_METADATA_TYPE.FRAMERATE;
  frameRate: number;
};